import React from 'react';
import ReconnectionAccountPageContent from './ReconnectionAccountPageContent';
import { IConsentInfoProps } from '../../types/IConsentInfoProps';
import ConsentStatus from '../../domain/enums/ConsentStatus';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import Container from '../container/Container';

interface IProps {
  consentInfo: IConsentInfoProps;
  bankLogoUrl?: string;
}

const ReconfirmationPageContent: React.FC<IProps> = (props: IProps) => {
  const { consentInfo, bankLogoUrl } = props;
  const { t } = useTranslation();
  const history = useHistory();

  const isConsentActive = consentInfo?.consentStatus === ConsentStatus.Active;

  return (
    <Container
      primaryBtn={{
        text: t(isConsentActive ? 'Reconfirm' : 'Reauthenticate'),
        onClick: () => {
          if (isConsentActive) {
            history.push('/reconfirmation-stage');
          } else {
            history.push('/consent');
          }
        }
      }}
    >
      <div data-testid="reconfirmation-page-content">
        <div className="mb-6">
          <h1 className="text-md md:text-lg text-primary-2 uppercase font-semi-bold mb-3">
            {t<string>('Manage Connections')}
          </h1>
          <p className={`text-md md:text-lg text-primary-2`}>
            {isConsentActive
              ? t(
                  `Regulation requires you to reconfirm your consent with us at least every 90 days if you wish to continue using the services of `
                ) + consentInfo?.customerName
              : t<string>(`Please re-authenticate your consent with us if you wish to use the services of {{name}}`, {
                  name: consentInfo?.customerName
                })}
          </p>
        </div>
        <ReconnectionAccountPageContent
          t={t}
          accounts={consentInfo?.accounts}
          lastUpdatedDate={consentInfo?.lastUpdatedDate}
          reconfirmByDate={consentInfo?.reconfirmByDate}
          bankName={consentInfo?.providerName}
          isActive={isConsentActive}
          bankLogoUrl={bankLogoUrl}
        />
      </div>
    </Container>
  );
};

export default ReconfirmationPageContent;
